import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const failedPaymentsList = (params = {}) => Http.get(`/failed-payments${serialize(params)}`)
export const failedPaymentsStats = (params = {}) => Http.get(`/failed-payments/stats${serialize(params)}`)
